<div mat-dialog-title>Create New Survey</div>
<mat-dialog-content class="fx-col fx-gap-20">
  <form [formGroup]="surveyForm" class="full-width" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px">

    <!-- Survey Name Field -->
    <div class="full-width" fxLayout="column" fxLayoutGap="7px">
      <span class="body-3-default">Survey Name</span>
      <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
        <input matInput formControlName="name" placeholder="Enter survey name">
        <mat-error *ngIf="surveyForm.get('name')!.hasError('required')">
          Survey name is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Survey Display Title Field -->
    <div class="full-width" fxLayout="column" fxLayoutGap="7px">
      <span class="body-3-default">Survey Display Title</span>
      <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
        <input matInput formControlName="displayTitle" placeholder="Enter survey display title">
        <mat-error *ngIf="surveyForm.get('displayTitle')!.hasError('required')">
          Survey display title is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Audience Field (Dropdown) -->
    <div class="full-width" fxLayout="column" fxLayoutGap="7px">
      <span class="body-3-default">Audience</span>
      <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
        <mat-select class="custom-select-field-value" placeholder="Select" formControlName="audience">
          <mat-option class="custom-select-field-option" [value]="AudienceCategory.GENERAL_PUBLIC">General public
          </mat-option>
          <!--        <mat-option class="custom-select-field-option" [value]="AudienceCategory.MERCHANTS">Merchants</mat-option>-->
        </mat-select>
        <mat-error *ngIf="surveyForm.get('audience')!.hasError('required')">
          Audience is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Start Date Field -->
    <div class="full-width" fxLayout="column" fxLayoutGap="7px">
      <span class="body-3-default">Start Date</span>
      <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
        <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Select start date">
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        <mat-error *ngIf="surveyForm.get('startDate')!.hasError('required')">
          Start date is required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- End Date Field -->
    <div class="full-width" fxLayout="column" fxLayoutGap="7px">
      <span class="body-3-default">End Date (optional)</span>
      <mat-form-field class="custom-select-field" appearance="outline" style="width: 100%;">
        <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="Select end date">
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Allow Multiple Submissions Toggle -->
    <div class="full-width" fxLayout="column" fxLayoutGap="7px">
      <span class="body-3-default">Allow Multiple Submissions</span>
      <mat-slide-toggle formControlName="allowMultiSubmission">
        Allow Multiple Submissions from the same user
      </mat-slide-toggle>
      <mat-hint class="footer-default">Allowing only a single submission per respondent will automatically add a
        mandatory email field to the form.
      </mat-hint>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button
          (click)="onCancel()"
          [disabled]="(loading$ | async)">
    Cancel
  </button>
  <button mat-flat-button color="primary"
          (click)="onSubmit()"
          [disabled]="!surveyForm.valid || (loading$ | async)">
    {{ (loading$ | async) ? 'Working...' : 'Create Survey' }}
  </button>
</mat-dialog-actions>
<mat-progress-bar mode="indeterminate" *ngIf="loading$ | async"></mat-progress-bar>
